import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Button } from 'antd';
import MobileHeader from '../../../components/mobile/Header';
import { ReactComponent as MaleSvg } from '../../../assets/icons/male.svg';
import { ReactComponent as FemaleSvg } from '../../../assets/icons/female.svg';

const { Title } = Typography;

const styles = {
  title: {
    color: '#404047',
    fontWeight: '700',
    fontSize: '24px'
  },
  itemTitle: {
    fontSize: 20,
    lineHeight: '24px',
    textAlign: 'center',
    fontWeight: '400'
  },
  box: {
    background: '#FFFFFF',
    border: '1px solid #F4F4F4',
    borderRadius: 5,
    marginRight: 12,
    marginBottom: 12
  }
};

const data = [
  {name: 'Sue', icon: <FemaleSvg />},
  {name: 'Joe', icon: <MaleSvg />},
  {name: 'Ahmed', icon: <MaleSvg />},
];

function MobileProfileSelect() {
  const { t } = useTranslation(['common', 'welcome']);
  const history = useHistory();

  const clickAvatar = (item) => {
    history.push('/homepage');
  }

  const renderAvatar = (item) => {
    return (
      <Col xs={12}>
        <Box paddingY={12} paddingX={18} style={styles.box}>
          <Box textAlign="center">
            {item.icon}
          </Box>
          <Title level={4} style={styles.itemTitle} onClick={() => clickAvatar(item)}>
            {item.name}
          </Title>
        </Box>
      </Col>
    )
  }

  return (
    <>
      <MobileHeader />
      <Box paddingTop={30} paddingBottom={12} paddingX={20}>
        <Row justify="center" style={{ padding: 0, marginBottom: 25 }}>
          <Col>
            <Title level={4} style={styles.title}>
              {t('welcome:login.profileTitle')}
            </Title>
          </Col>
        </Row>
        <Row>
          {data.map((item) => renderAvatar(item))}
        </Row>
      </Box>
    </>
  );
}

export default MobileProfileSelect;
